import type { PreloadedState } from '@reduxjs/toolkit';
import { Container } from 'inversify';

import type { RootState } from '@/features/store';

import 'reflect-metadata';

import ConfigService, { IConfigService } from './ConfigService';
import GrpcService, { IGrpcService } from './GrpcService';
import I18Service, { II18Service } from './I18Service';
import NavigationService, { INavigationService } from './NavigationService';
import ServiceTypes from './ServiceTypes';
import SsrService, { ISsrService } from './SsrService';

const injectContainer = new Container();

export const initServices = (preloadedState: PreloadedState<RootState>) => {
  const method = injectContainer.isBound(ServiceTypes.Config) ? 'rebind' : 'bind';

  injectContainer[method]<IConfigService>(ServiceTypes.Config)
    .toDynamicValue(_ => {
      return new ConfigService(preloadedState);
    })
    .inSingletonScope();

  injectContainer[method]<INavigationService>(ServiceTypes.Navigation)
    .to(NavigationService)
    .inSingletonScope();

  injectContainer[method]<ISsrService>(ServiceTypes.Ssr)
    .to(SsrService)
    .inSingletonScope();

  injectContainer[method]<IGrpcService>(ServiceTypes.Grpc)
    .to(GrpcService)
    .inSingletonScope();

  injectContainer[method]<II18Service>(ServiceTypes.I18N)
    .to(I18Service)
    .inSingletonScope();
};

export default injectContainer;
